/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SeriesItem } from './SeriesItem';
import { selectSeries } from '../Viewer/Layout/LayoutUtils';
import { onDragHandler } from '../../../util/DragnDrop';
import { PlaceholderThumbnail } from './styled/StyledExplorer';
import { getCurrentStudy } from '../../../util/studiesManager';

const Loading = ({ key }) => {
  const { t } = useTranslation();
  return <PlaceholderThumbnail>{t('loading.snapshot')}</PlaceholderThumbnail>;
};

export const SeriesExplorer = () => {
  const appConfig = useSelector((state) => state.config);
  const patient = useSelector((state) => state.patient);
  const layout = useSelector((state) => state.layout);

  const iconSize = '1em';
  const { patientHistory } = patient;
  const currentSerieUID = layout.elements[layout.selectedViewIndex] && layout.elements[layout.selectedViewIndex].SeriesInstanceUID ? layout.elements[layout.selectedViewIndex].SeriesInstanceUID : undefined;
  const [selection, setSelection] = useState(currentSerieUID);
  const selectedStudy = getCurrentStudy(patient);
  const patientHistoryData = patientHistory && patientHistory.length > 0 && patient.mainStudyId && patientHistory.filter((fst) => fst.StudyInstanceUID === patient.mainStudyId);
  const servers = (patientHistoryData && patientHistoryData.length > 0 && patientHistoryData[0].servers) || selectedStudy.servers;

  const select = (e, selectedStudy, serie) => {
    e.preventDefault();
    selectSeries(selectedStudy, serie, layout.selectedViewIndex);
  };

  useEffect(() => {
    setSelection(currentSerieUID);
  }, [currentSerieUID]);

  const numOfSeries = selectedStudy.series && selectedStudy.series.length;

  const studySeries = [];
  for (let i = 0; i < numOfSeries; i++) {
    if (selectedStudy.series && selectedStudy.series[i]) {
      studySeries.push(selectedStudy.series[i]);
    }
  }

  return (
    <>
      {studySeries.map((serie, index) => {
        if (serie === undefined) return <Loading key={`index-${(`00${index.toString()}`).slice(-3)}`} />;

        if (!serie.instances) return <Loading key={serie.SeriesInstanceUID} />;

        if (serie.instances && serie.instances.length < 1) return null;

        return (
          <SeriesItem
            key={serie.SeriesInstanceUID}
            appConfig={appConfig}
            id={serie.SeriesInstanceUID}
            iconSize={iconSize}
            selected={selection && selection.includes(serie.SeriesInstanceUID)}
            study={selectedStudy}
            series={serie}
            currentSerieUID={currentSerieUID}
            servers={servers}
            onClick={(e) => {
              select(e, selectedStudy, serie);
            }}
            onDrag={(e) => {
              onDragHandler(e, index, selectedStudy, serie);
            }}
          />
        );
      })}
    </>
  );
};
